// #region Estado interno & persistência
const LS_KEY = 'mock.vendas.v1';
let _vendas = [];
try {
	const raw = JSON.parse(localStorage.getItem(LS_KEY) || '[]');
	if (Array.isArray(raw)) _vendas = raw;
} catch {}
function persist() { localStorage.setItem(LS_KEY, JSON.stringify(_vendas)); }
// #endregion

// #region Util
const delay = (ms = 240) => new Promise(r => setTimeout(r, ms));
// #endregion

// #region Métodos públicos
export async function listAll() {
	await delay();
	return _vendas.map(v => ({ ...v }));
}

export async function create(venda) {
	await delay();
	const id = Date.now();
	const now = new Date();
	const nova = { id, data_hora: now.toISOString(), status: 'FINALIZADA', ...venda };
	_vendas = [nova, ..._vendas];
	persist();
	return { ...nova };
}

export async function remove(id) {
	await delay();
	_vendas = _vendas.filter(v => v.id !== id);
	persist();
	return true;
}
// #endregion

// #region Export default
const vendasApi = { listAll, create, remove };
export default vendasApi;
// #endregion
